import {
  DocumentNode,
  MutationHookOptions,
  MutationFunctionOptions,
  MutationResult,
  useMutation as apolloUseMutation,
} from '@apollo/client';
import { executeRequest, removeTypeName } from 'services/graphql';
import Response from 'services/graphql/response';
import ResponseError from 'services/graphql/response-error';
import apolloClient from 'services/apollo-client';

export default function useMutation<TData = any, TVariables = any>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables>,
): [
  (
    options?: MutationFunctionOptions<TData, TVariables>,
  ) => Promise<Response<any> | ResponseError<Error>>,
  MutationResult<TData>,
] {
  const [mutationFunction, data] = apolloUseMutation<TData, TVariables>(
    mutation,
    // @ts-ignore
    { client: apolloClient, ...options },
  );

  function mutationOperation(
    options?: MutationFunctionOptions,
  ): Promise<Response<any> | ResponseError<Error>> {
    if (options?.variables) {
      options.variables = removeTypeName(options.variables);
    }

    const callable = () => mutationFunction(options as any);

    return executeRequest(callable);
  }

  return [mutationOperation, data] as any;
}
